<template lang="pug">
  .page-container
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container
      v-card.form-container
        v-tabs(fixed-tabs grow v-model="tabIndex")
          v-tab(key='login') {{ $t("account.hasAccount") }}
          v-tab(key='register') {{ $t("account.noAccount") }}
          v-tab-item(key='login-item')
            v-form.form-content(ref="loginForm")
              v-layout
                v-flex
                  v-text-field(
                    :label='$t("account.phoneNumber")'
                    :rules="fieldRules"
                    outline
                    v-model="login_phone"
                    ref="login_phone"
                  )
              v-layout
                v-flex
                  v-text-field(
                    :rules="fieldRules"
                    :label='$t("account.password")'
                    outline
                    v-model="login_password"
                    ref="login_password"
                    type="password"
                  )
              v-btn.btn(color="primary" round block @click="login" :loading='loginLoading') {{ $t("account.login") }}
          v-tab-item(key='register-item')
            v-form.form-content(ref="registerForm")
              v-layout
                v-flex
                  v-text-field(
                    outline
                    ref="phone"
                    :label='$t("account.phoneNumber")'
                    :rules="fieldRules"
                    v-model="register_phone"
                  )
              v-layout
                v-flex
                  v-text-field(
                    :label='$t("account.nickname")'
                    :rules="fieldRules"
                    outline
                    v-model="register_name"
                    ref="name"
                  )
              v-layout
                v-flex
                  v-text-field(
                    :rules="fieldRules"
                    :label='$t("account.password")'
                    outline
                    v-model="register_password"
                    ref="password"
                    type="password"
                  )
              v-layout
                v-flex
                  v-text-field(
                    :rules="fieldRules"
                    :label='$t("account.confirmPassword")'
                    outline
                    v-model="register_rePassword"
                    ref="rePassword"
                    type="password"
                  )

              .tip-container
                div {{ $t("account.hasQuestions") }}
                div 688 020 521
              v-btn.btn(color="primary" round block @click="register" :loading='registerLoading') {{ $t("account.register") }}

</template>

<script>
import { mapMutations } from "vuex";
import account from ".././../api/account.js";

export default {
  data() {
    return {
      tabIndex: null,
      register_phone: null,
      register_name: null,
      register_password: null,
      register_rePassword: null,
      register_countryCode: 34,
      login_countryCode: 34,
      login_phone: null,
      login_password: null,
      loginLoading: false,
      registerLoading: false
    };
  },
  computed: {
    fieldRules() {
      return [value => !!value || this.$t("account.required")];
    },
    countryCode() {
      return [
        value =>
          /^[A-Za-z0-9]+$/.test(value) ||
          this.$t("account.enterNumbersOrLetters")
      ];
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "account" },
          disabled: true,
          text:
            this.tabIndex == 0
              ? this.$t("account.login")
              : this.$t("account.register")
        }
      ];
    },
    registerForm() {
      return {
        phone: this.register_phone,
        password: this.register_password,
        rePassword: this.register_rePassword,
        name: this.register_name
      };
    },
    loginForm() {
      return {
        login_phone: this.login_phone,
        login_password: this.login_password,
        login_countryCode: this.login_countryCode
      };
    }
  },
  methods: {
    ...mapMutations(["setToken", "setUserInfo"]),

    register() {
      let formHasErrors = true;
      Object.keys(this.registerForm).forEach(f => {
        if (!this.registerForm[f]) {
          this.$refs[f].validate(true);
          formHasErrors = false;
        }
      });

      if (formHasErrors) {
        this.handleRegister();
      }
    },

    async handleRegister() {
      this.registerLoading = true;
      try {
        const res = await account.register({
          ...this.registerForm,
          countryCode: this.register_countryCode
        });
        this.registerLoading = false;

        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.$toasted.success(this.$t("account.registerSuccess"));
        }
      } catch (e) {
        console.log(e);
      }
    },

    login() {
      let formHasErrors = true;

      Object.keys(this.loginForm).forEach(f => {
        if (!this.loginForm[f]) {
          this.$refs[f].validate(true);
          formHasErrors = false;
        }
      });

      if (formHasErrors) {
        this.handleLgin();
      }
    },

    async handleLgin() {
      this.loginLoading = true;
      try {
        const res = await account.login({
          phone: this.loginForm.login_phone,
          password: this.loginForm.login_password,
          countryCode: this.loginForm.login_countryCode
        });
        this.loginLoading = false;

        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.$toasted.success(this.$t("account.loginSuccess"));
          this.setToken(res.data.data.token);
          this.loadUserInfo();
          setTimeout(() => {
            this.$router.push({ name: "shop" });
          }, 500);
        }
      } catch (e) {
        console.log(e);
      }
    },

    async loadUserInfo() {
      try {
        const res = await account.getInfo();
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.setUserInfo(res.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
<style scoped lang="sass" src="./account.sass"></style>
